export const ADMIN_LOGIN_REQUEST = 'ADMIN_LOGIN_REQUEST';
export const ADMIN_LOGIN_SUCCESS = 'ADMIN_LOGIN_SUCCESS';
export const ADMIN_LOGIN_FAILURE = 'ADMIN_LOGIN_FAILURE';
export const ADMIN_LOGIN_CHOOSE_WORKFLOW = 'ADMIN_LOGIN_CHOOSE_WORKFLOW';
export const GET_WORKFLOWS_REQUEST = 'GET_WORKFLOWS_REQUEST';
export const GET_WORKFLOWS_SUCCESS = 'GET_WORKFLOWS_SUCCESS';
export const GET_WORKFLOWS_FAILURE = 'GET_WORKFLOWS_FAILURE';
